export {Events as default};

class Events {
    static PUSH_NOTIFICATIONS_MESSAGE = 'PUSH_NOTIFICATIONS_MESSAGE';

    static PUSH_NOTIFICATIONS_CLICK = 'PUSH_NOTIFICATIONS_CLICK';

    static PRELOADER_REMOVED = 'PRELOADER_REMOVED';

    static VIEWPORT_UPDATED = 'VIEWPORT_UPDATED';
}